var _path, _path2, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChainListIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 112,
    viewBox: "0 0 99 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7158 8.25213C36.6209 -5.22951 64.8631 3.26477 82.7967 27.2247C100.73 51.184 101.564 81.5361 84.6589 95.0181C67.7538 108.499 39.5116 100.005 21.578 76.0456C3.64455 52.0858 2.8108 21.7337 19.7158 8.25213Z",
    fill: "#DAF727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5295 15.8584C22.2995 8.86419 33.9492 7.62502 45.5959 11.1279C57.2408 14.6303 68.9559 22.8847 78.0344 35.0137C87.1132 47.1433 91.8855 60.9177 92.2287 73.4111C92.5717 85.8999 88.4827 97.2002 79.7199 104.188C70.9499 111.182 59.3002 112.421 47.6535 108.918C36.0086 105.416 24.2935 97.1622 15.215 85.0332C6.13613 72.9035 1.3629 59.1283 1.01971 46.6348C0.676775 34.1462 4.76676 22.8464 13.5295 15.8584Z",
    fill: "#5235E8",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 27,
    width: 50,
    height: 67
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 61,
    transform: "translate(21.7138 33.6544) rotate(-9.54191)",
    fill: "url(#pattern0_1_130)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.7138,
    y: 33.6544,
    width: 39,
    height: 61,
    transform: "rotate(-9.54191 21.7138 33.6544)",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1_130",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_130",
    transform: "scale(0.025641 0.0163934)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_130",
    width: 39,
    height: 61,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChainListIcon3);
export default __webpack_public_path__ + "static/media/chain-list-icon-3.016213ce33d31673914364d24611ae2b.svg";
export { ForwardRef as ReactComponent };